var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRisk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 18,
    fill: "#F2FFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6761 39.8883C18.6868 39.8986 18.7 39.906 18.7143 39.9096C18.7352 39.9148 18.7566 39.9172 18.7781 39.9167H41.2124C41.2339 39.9172 41.2553 39.9148 41.2762 39.9096C41.2906 39.906 41.3037 39.8986 41.3144 39.8883L30.1114 20.1272C30.1072 20.1207 30.1025 20.1146 30.0973 20.1088L30.0902 20.1032C30.076 20.0961 30.0434 20.0833 29.9953 20.0833C29.9471 20.0833 29.9131 20.0961 29.9003 20.1032L29.8933 20.1088C29.8933 20.1088 29.8904 20.1088 29.889 20.1131C29.8854 20.1176 29.8821 20.1223 29.8791 20.1272L18.6761 39.8883ZM41.2124 42.75H18.7781C16.5369 42.75 15.1174 40.4196 16.1969 38.5156L27.4141 18.7304C28.5333 16.757 31.4573 16.757 32.5764 18.7304L43.7936 38.5142C44.8731 40.4196 43.4536 42.75 41.2124 42.75Z",
    fill: "#43BC33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4115 25.75H28.5781V34.25H31.4115V25.75ZM31.4115 35.6667H28.5781V38.5H31.4115V35.6667Z",
    fill: "#43BC33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk);
export default __webpack_public_path__ + "static/media/risk.41b264acce6a40442c15159172b1c717.svg";
export { ForwardRef as ReactComponent };